"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ErrorPage["default"];
  }
});
var _ErrorPage = _interopRequireDefault(require("./ErrorPage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }